import { useEffect, useState, useRef } from 'react'
import NationalCodeControl from "../../../Controls/NationalCodeControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Login.css"
import {
	SetLocal,
	ClearLocal,
	FetchService,
	IsValidNationalCode,
	IsEmptyString,
	IsEmptyInput
} from "../../../Base/BaseControl";
import { toast } from 'react-toastify';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import SelectControl from '../../../Controls/SelectControl';

export default function Index({ Click, page }) {

	const navigate = useNavigate();
	const textBoxFileNumberRef = useRef(null);
	const [getTextBoxFileNumberRef, setTextBoxFileNumberRef] = useState(true);
	const [getStep, setStep] = useState(0);

	const inputSelectRef = useRef(null);
	const [getSelectData, setSelectData] = useState([]);
	const [comboRegionDisabled, setComboRegionDisabled] = useState(true);
	const [isConnectionAttrributeCalled, setIsConnectionAttrributeCalled] = useState(false);

	const textTrade1Ref = useRef(null);
	const textTrade2Ref = useRef(null);
	const textTrade3Ref = useRef(null);
	const textTrade4Ref = useRef(null);
	const textTrade5Ref = useRef(null);
	const textTrade6Ref = useRef(null);

	useEffect(() => {
		loadCaptchaEnginge(5, 'white', 'black', 'numbers');
		document.querySelector('#reload_href').innerHTML = "کد امنیتی مجدد";
		document.querySelector('#reload_href').classList.add('refresh');
	}, []);

	useEffect(() => {
		var inputValue = {};
		FetchService("General/IsMultiRegion", inputValue, IsMultiRegionSuccess, IsMultiRegionFail);


	}, []);
	const IsMultiRegionSuccess = (ServiceResult) => {
		var inputValue = {};
		FetchService("General/Abstract/BasicInfo/ShowRegionAbstractList", inputValue, ShowRegionAbstractListSuccess);
	}
	const IsMultiRegionFail = (ServiceResult) => {
		setComboRegionDisabled(true)
	}

	const ShowRegionAbstractListSuccess = (ServiceResult) => {
		setSelectData(ServiceResult.RegionInfo);
		setComboRegionDisabled(false)
	}

	const GetConnetionAttribute = () => {
		let input = {
			regionCode: inputSelectRef.current?.value || 0,
		}
		FetchService("General/GetConnectionAttribute", input, GetConnetionAttributeSuccess)
	}
	const GetConnetionAttributeSuccess = (ServiceResult) => {
		if (ServiceResult) {
			setIsConnectionAttrributeCalled(true)
		}
	}

	const GetSessionByFileNumber = () => {
		if (IsEmptyInput(textBoxFileNumberRef))
			return false;

		if (!comboRegionDisabled && (!isConnectionAttrributeCalled || IsEmptyInput(inputSelectRef))) {
			toast.error('لطفا منطقه را انتخاب نمایید');
			return false;
		}

		let user_captcha = document.getElementById('user_captcha_input').value;
		if (!validateCaptcha(user_captcha) === true) {
			toast.error('لطفا کد امنیتی را وارد نمایید');
			return false;
		}

		var inputValue = {
			fileNumber: textBoxFileNumberRef.current.value,
			regionID: comboRegionDisabled ? 0 : inputSelectRef.current.value
		};
		FetchService("Owner/Trade/Security/GetSessionByFileNumber", inputValue, GetSessionByFileNumberSuccess);
	}

	const GetSessionByFileNumberSuccess = (serviceResult) => {
		localStorage.clear();
		SetLocal('TradeSession', serviceResult.SessionValue);
		navigate("/Trade/ShowBusinessToll?page=مشاهده عوارض کسب و پیشه");
	}

	const GetSessionByRenovationCode = () => {
		if (IsEmptyInput(textTrade1Ref) ||
			IsEmptyInput(textTrade2Ref) ||
			IsEmptyInput(textTrade3Ref) ||
			IsEmptyInput(textTrade4Ref) ||
			IsEmptyInput(textTrade5Ref) ||
			IsEmptyInput(textTrade6Ref)
		)
			return false;

		let user_captcha = document.getElementById('user_captcha_input').value;
		if (!validateCaptcha(user_captcha) === true) {
			document.getElementById('user_captcha_input').style.border = "1px solid #ff0000cc"
			//toast.error('لطفا کد امنیتی را وارد نمایید');
			return false;
		}

		var inputValue = {
			area: textTrade6Ref.current.value,
			district: textTrade5Ref.current.value,
			block: textTrade4Ref.current.value,
			parcel: textTrade3Ref.current.value,
			apartment: textTrade2Ref.current.value,
			trade: textTrade1Ref.current.value,
			regionID: Number(inputSelectRef.current?.value) || 0
		};

		FetchService("Owner/Trade/Security/GetSessionByRenovationCode", inputValue, GetSessionByRenovationCodeSuccess);
	}

	const GetSessionByRenovationCodeSuccess = (serviceResult) => {
		localStorage.clear();
		SetLocal('TradeSession', serviceResult.SessionValue);
		navigate("/Trade/ShowBusinessToll?page=مشاهده عوارض کسب و پیشه");
	}

	const handleStep = (value) => {
		setStep(value);
	}

	return (
		<div id="bglogin">
			<div className="main">
				<div className="formLogin">
					<div>
						<input onClick={() => handleStep(0)} type="radio" name="handleStep" checked={getStep === 0} /> شماره پرونده &nbsp;&nbsp;&nbsp;
						<input onClick={() => handleStep(1)} type="radio" name="handleStep" checked={getStep === 1} />	کد نوسازی
						<br /><br />
					</div>
					<div className='my-3'>
						<SelectControl
							data={getSelectData}
							inputRef={inputSelectRef}
							title={"منطقه:"}
							required={!comboRegionDisabled}
							disabled={comboRegionDisabled}
							onChange={() => GetConnetionAttribute()}
						/>
					</div>
					{getStep == 0 &&
						<div>
							<TextBoxControl
								inputRef={textBoxFileNumberRef}
								title="شماره پرونده:"
								required={true}
								placeholder="شماره پرونده خود را وارد نمایید"
								onlyNumbers={true}
								maxlength="15"
							/>
						</div>
					}
					{getStep == 1 &&
						<div>
							<div id="inpCode">
								<TextBoxControl tabindex="6" inputRef={textTrade1Ref} placeholder="ردیف" />
								<TextBoxControl className="smallPlaceholder" tabindex="5" inputRef={textTrade2Ref} placeholder="آپارتمان" />
								<TextBoxControl tabindex="4" inputRef={textTrade3Ref} placeholder="ملک" />
								<TextBoxControl tabindex="3" inputRef={textTrade4Ref} placeholder="بلوک" />
								<TextBoxControl tabindex="2" inputRef={textTrade5Ref} placeholder="حوزه" />
								<TextBoxControl tabindex="1" inputRef={textTrade6Ref} placeholder="منطقه" />
							</div>
							<br />
						</div>
					}
					<div class="d-flex">
						<div><input id="user_captcha_input" tabindex="7" placeholder="کد امنیتی" maxlength="5" class="form-control" name="user_captcha_input" type="text"></input></div>
						<LoadCanvasTemplate />
					</div>

					{getStep == 0 &&
						<div>
							<ButtonControl
								onClick={GetSessionByFileNumber}
								variant="primary"
								title="ارسال"
							/>
							<ButtonControl
								onClick={() => navigate("/")}
								variant="danger mx-2"
								title="بازگشت"
							/>
						</div>
					}
					{getStep == 1 &&
						<div>
							<ButtonControl
								onClick={GetSessionByRenovationCode}
								variant="primary"
								title="ارسال"
							/>
							<ButtonControl
								onClick={() => navigate("/")}
								variant="danger mx-2"
								title="بازگشت"
							/>
						</div>
					}
				</div>
			</div>
		</div>
	);
}